<template>
    <div class="sample-dashboard">
      <v-container>
        <v-row no-gutters>
          <v-col md="4">
            <barplotly 
              v-for="colTrack in col1"
              :key="colTrack"
              :divId="`barplot-${colTrack}`"
              :track="colTrack"
              :trackDetails="tracks"
              :sampleMeta="sampleMetaStudy"
              :stratifyVar="stratifyVar"
            />
          </v-col>
          <v-col md="4">
              <barplotly 
                :key="colTrack"
                v-for="colTrack in col2"
                :divId="`barplot-${colTrack}`"
                :track="colTrack"
                :trackDetails="tracks"
                :sampleMeta="sampleMetaStudy"
                :stratifyVar="stratifyVar"
            />
          </v-col>
            <v-col md="4">
              <barplotly 
                :key="colTrack"
                v-for="colTrack in col3"
                :divId="`barplot-${colTrack}`"
                :track="colTrack"
                :trackDetails="tracks"
                :sampleMeta="sampleMetaStudy"
                :stratifyVar="stratifyVar"
            />
          </v-col>
        </v-row> 
      </v-container>
    </div>
</template>

<script>
import trackDetailsPTRC from '../refs/trackDetails'
import trackDetailsPCC from '../refs/trackDetailsPCC'

import Barplotly from './Barplotly.vue'
import sampleMetaPTRC from '../refs/sampleMeta'
import sampleMetaPCC from '../refs/sampleMetaPCC'
import { sample } from 'lodash'


export default {
    components: { Barplotly },
    name: "sample-dashboard",

    props: ['studySelected'],

    data: () => ({
      // tracks: trackDetails,
      // sampleMetaCohort: sampleMeta,
      col1: [],
      col2: [],
      col3: [],
      // sampleMetaStudy: {},
    }),
    
    computed: {
      tracks() {
        if (this.studySelected === 'PCC') {
          return trackDetailsPCC
        } else {
          return trackDetailsPTRC
        }
      },
      sampleMetaStudy() {
        if (this.studySelected === 'PCC') {
          return sampleMetaPCC 
        } else {
          return sampleMetaPTRC
        }
      },

      trackList() {
            // get() {
          // console.log('get sampleDashboardTracks', this.studySelected)
          // console.log('get sampleDashboardTracks tracks', this.categoryTracks)

          if (this.studySelected === 'PCC') {
              return this.$store.state.sampleDashboard_PCCgraphs
          } else {
              return this.$store.state.sampleDashboard_PTRCgraphs
          }
                //  },
        },
      stratifyVar() {
        if (this.studySelected === 'PCC') {
              return this.$store.state.stratifyVar['PCC']
          } else {
              return this.$store.state.stratifyVar['PTRC']
          }
      }
      // trackList() { return this.$store.state.sampleDashboard_PTRCgraphs },
      // barplotCategory() { return this.$store.state.barplotCategory },
      // trackDetails() { return this.$store.state.trackDetails }, 
      // graphs() { return this.$store.state.sampleDashboardGraphs },
    },

    watch: {
      trackList() {
        let allCols = [[], [], []]
        let i = 0
        this.trackList.forEach((track, j) => {
          if (i === 3) { i = 0 }
          allCols[i].push(track)
          i += 1
        })
        this.col1 = allCols[0]
        this.col2 = allCols[1]
        this.col3 = allCols[2]
      },
      studySelected() {
      }
    },

    mounted() {
      let allCols = [[], [], []]
      let i = 0
      this.trackList.forEach((track, j) => {
        if (i === 3) { i = 0 }
        allCols[i].push(track)
        i += 1
      })
      this.col1 = allCols[0]
      this.col2 = allCols[1]
      this.col3 = allCols[2]
    }
  }

</script>

<style scoped>
    .sample-dashboard {
        width: 75%;
        min-width: 600px;
        display: flex;
        flex-direction: column;
        margin: 10px;
        padding-left: 10px;
        overflow: scroll;
    }

    .sample-dashboard-header {
      margin: 0 auto;
      font-size: 1.2em;
      font-weight: bold;
    }
</style>